"use client";

import { c as _c } from "react/compiler-runtime";
import { Article, LocalShipping } from "@mui/icons-material";
import Link from "next/link";
import React, { useMemo } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { Button, ButtonSize, ButtonVariant, Progress, ProgressColor, Text, TextSize, TextVariant, TextWeight } from "../../components";
import { useMatchBreakpoints } from "../../hooks";
import { parseProductName } from "../../utils";
import { ReturnedProductListItem } from "../ReturnedProductListItem";
const ReturnDetails = t0 => {
  const $ = _c(168);
  const {
    customReturn,
    onPayAgain,
    onGetDhlLabel
  } = t0;
  const {
    isXs,
    isSm,
    isMd
  } = useMatchBreakpoints();
  const isMobile = isXs || isSm || isMd;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  t1 = t2;
  const sliderSettings = t1;
  if (!customReturn) {
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex items-center justify-center h-full"><Progress color={ProgressColor.GRAYSCALE_400} /></div>;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  const formatDate = _temp;
  let t3;
  if ($[2] !== customReturn.order.history) {
    t3 = () => {
      if (!customReturn.order.history?.current) {
        return "Brak danych";
      }
      return customReturn.order.history.current.ostateName || "Brak danych";
    };
    $[2] = customReturn.order.history;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getCurrentOrderState = t3;
  let t4;
  if ($[4] !== customReturn.order.shipping) {
    t4 = () => {
      if (customReturn.order.shipping && customReturn.order.shipping.length > 0) {
        return customReturn.order.shipping[0]?.trackingNumber || "Brak numeru";
      }
      return "Brak numeru";
    };
    $[4] = customReturn.order.shipping;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getTrackingNumber = t4;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== customReturn.customReturn.dateAdd || $[7] !== customReturn.customReturn.idOrderReturn || $[8] !== customReturn.customReturn.p24Amount || $[9] !== customReturn.customReturn.paymentMethod || $[10] !== customReturn.customReturn.returnMethod.instruction || $[11] !== customReturn.customReturn.returnMethod.title || $[12] !== customReturn.inpostReturnCode.message || $[13] !== customReturn.inpostReturnCode.showCode || $[14] !== customReturn.order.details?.id || $[15] !== customReturn.order.details?.orderDate || $[16] !== customReturn.order.details?.payment || $[17] !== customReturn.order.details?.shipping || $[18] !== customReturn.orderReturn.printUrl || $[19] !== customReturn.orderReturnAddress.accountNumberReturn || $[20] !== customReturn.orderReturnAddress.returnApartmentNumber || $[21] !== customReturn.orderReturnAddress.returnCity || $[22] !== customReturn.orderReturnAddress.returnHouseNumber || $[23] !== customReturn.orderReturnAddress.returnName || $[24] !== customReturn.orderReturnAddress.returnPhone || $[25] !== customReturn.orderReturnAddress.returnPostcode || $[26] !== customReturn.orderReturnAddress.returnStreet || $[27] !== customReturn.paymentStatus.payAgain || $[28] !== customReturn.paymentStatus.title || $[29] !== customReturn.returnedProducts || $[30] !== getCurrentOrderState || $[31] !== getTrackingNumber || $[32] !== isMobile || $[33] !== onGetDhlLabel || $[34] !== onPayAgain) {
    let t15;
    if ($[45] !== customReturn.returnedProducts) {
      t15 = customReturn.returnedProducts || {};
      $[45] = customReturn.returnedProducts;
      $[46] = t15;
    } else {
      t15 = $[46];
    }
    const productsArray = Object.values(t15);
    let t16;
    if ($[47] !== isMobile) {
      t16 = products => {
        if (products) {
          const parsedProducts = products.map(_temp2);
          if (isMobile) {
            return <SliderWrapper><Slider {...sliderSettings}>{parsedProducts.map(_temp3)}</Slider></SliderWrapper>;
          }
          return <div className="space-y-3">{parsedProducts.map(_temp4)}</div>;
        }
        return <Text text="Brak danych o produktach" fontSize={TextSize.M} />;
      };
      $[47] = isMobile;
      $[48] = t16;
    } else {
      t16 = $[48];
    }
    const renderProducts = t16;
    const formatAccountNumber = _temp5;
    if ($[49] !== customReturn.customReturn.idOrderReturn || $[50] !== customReturn.paymentStatus.payAgain || $[51] !== onPayAgain) {
      t9 = customReturn.paymentStatus.payAgain === "1" && <div className="bg-yellow-50 shadow-sm p-6 mb-6 flex justify-between items-center"><Text text={"Zwrot oczekuje na p\u0142atno\u015B\u0107. Prosimy jej dokona\u0107 klikaj\u0105c w przycisk \"Pon\xF3w p\u0142atno\u015B\u0107 Przelewy24\"."} fontSize={TextSize.M} /><Button text={"Pon\xF3w p\u0142atno\u015B\u0107 Przelewy24"} variant={ButtonVariant.SECONDARY} size={ButtonSize.XS} onClick={() => onPayAgain(customReturn.customReturn.idOrderReturn)} /></div>;
      $[49] = customReturn.customReturn.idOrderReturn;
      $[50] = customReturn.paymentStatus.payAgain;
      $[51] = onPayAgain;
      $[52] = t9;
    } else {
      t9 = $[52];
    }
    const t17 = `Szczegóły zwrotu: ${customReturn.customReturn.idOrderReturn}`;
    if ($[53] !== t17) {
      t10 = <div className="mb-6"><Text text={t17} variant={TextVariant.H5} weight={TextWeight.BOLD} /></div>;
      $[53] = t17;
      $[54] = t10;
    } else {
      t10 = $[54];
    }
    let t18;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <div className="mb-6"><Text text={"Informacje o zam\xF3wieniu"} variant={TextVariant.H6} weight={TextWeight.BOLD} /></div>;
      $[55] = t18;
    } else {
      t18 = $[55];
    }
    let t19;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <span className="text-sm text-gray-600">Numer zamówienia:</span>;
      $[56] = t19;
    } else {
      t19 = $[56];
    }
    const t20 = customReturn.order.details?.id;
    let t21;
    if ($[57] !== t20) {
      t21 = <div>{t19}<p className="font-semibold">{t20}</p></div>;
      $[57] = t20;
      $[58] = t21;
    } else {
      t21 = $[58];
    }
    let t22;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <span className="text-sm text-gray-600">Złożone:</span>;
      $[59] = t22;
    } else {
      t22 = $[59];
    }
    const t23 = customReturn.order.details?.orderDate;
    let t24;
    if ($[60] !== t23) {
      t24 = formatDate(t23);
      $[60] = t23;
      $[61] = t24;
    } else {
      t24 = $[61];
    }
    let t25;
    if ($[62] !== t24) {
      t25 = <div>{t22}<p className="font-semibold">{t24}</p></div>;
      $[62] = t24;
      $[63] = t25;
    } else {
      t25 = $[63];
    }
    let t26;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
      t26 = <span className="text-sm text-gray-600">Status:</span>;
      $[64] = t26;
    } else {
      t26 = $[64];
    }
    let t27;
    if ($[65] !== getCurrentOrderState) {
      t27 = getCurrentOrderState();
      $[65] = getCurrentOrderState;
      $[66] = t27;
    } else {
      t27 = $[66];
    }
    let t28;
    if ($[67] !== t27) {
      t28 = <div>{t26}<p className="font-semibold">{t27}</p></div>;
      $[67] = t27;
      $[68] = t28;
    } else {
      t28 = $[68];
    }
    let t29;
    if ($[69] !== getTrackingNumber) {
      t29 = getTrackingNumber() !== "Brak numeru" && <div><span className="text-sm text-gray-600">Nr przesyłki:</span><p className="font-semibold text-sm">{getTrackingNumber()}</p></div>;
      $[69] = getTrackingNumber;
      $[70] = t29;
    } else {
      t29 = $[70];
    }
    let t30;
    if ($[71] !== t21 || $[72] !== t25 || $[73] !== t28 || $[74] !== t29) {
      t30 = <div className="bg-gray-50 shadow-sm p-6 mb-6"><div className="grid grid-cols-2 md:grid-cols-4 gap-4">{t21}{t25}{t28}{t29}</div></div>;
      $[71] = t21;
      $[72] = t25;
      $[73] = t28;
      $[74] = t29;
      $[75] = t30;
    } else {
      t30 = $[75];
    }
    let t31;
    if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
      t31 = <Text text="Forma dostawy" weight={TextWeight.BOLD} />;
      $[76] = t31;
    } else {
      t31 = $[76];
    }
    const t32 = customReturn.order.details?.shipping[0]?.stateName || "Brak danych";
    let t33;
    if ($[77] !== t32) {
      t33 = <div className="bg-gray-50 shadow-sm p-6 mb-0 md:mb-6 flex flex-col gap-2">{t31}<Text text={t32} /></div>;
      $[77] = t32;
      $[78] = t33;
    } else {
      t33 = $[78];
    }
    let t34;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
      t34 = <Text text={"Forma p\u0142atno\u015Bci"} weight={TextWeight.BOLD} />;
      $[79] = t34;
    } else {
      t34 = $[79];
    }
    const t35 = customReturn.order.details?.payment || "Brak danych";
    let t36;
    if ($[80] !== t35) {
      t36 = <div className="bg-gray-50 shadow-sm p-6 mb-6 flex flex-col gap-2">{t34}<Text text={t35} /></div>;
      $[80] = t35;
      $[81] = t36;
    } else {
      t36 = $[81];
    }
    let t37;
    if ($[82] !== t33 || $[83] !== t36) {
      t37 = <div className="grid md:grid-cols-2 gap-6">{t33}{t36}</div>;
      $[82] = t33;
      $[83] = t36;
      $[84] = t37;
    } else {
      t37 = $[84];
    }
    if ($[85] !== t30 || $[86] !== t37) {
      t11 = <>{t18}{t30}{t37}</>;
      $[85] = t30;
      $[86] = t37;
      $[87] = t11;
    } else {
      t11 = $[87];
    }
    let t38;
    if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
      t38 = <div className="mb-6"><Text text="Informacje o zwrocie" variant={TextVariant.H6} weight={TextWeight.BOLD} /></div>;
      $[88] = t38;
    } else {
      t38 = $[88];
    }
    let t39;
    if ($[89] !== customReturn.orderReturn.printUrl || $[90] !== customReturn.paymentStatus.payAgain) {
      t39 = customReturn.orderReturn.printUrl && customReturn.paymentStatus.payAgain !== "1" && <Link href={customReturn.orderReturn.printUrl} target="_blank"><div className="mb-6 border border-yellow-200 p-6 flex justify-center gap-2 bg-yellow-50 cursor-pointer"><div className="flex gap-2"><Article /><Text text="Pobierz formularz zwrotu" weight={TextWeight.BOLD} /></div></div></Link>;
      $[89] = customReturn.orderReturn.printUrl;
      $[90] = customReturn.paymentStatus.payAgain;
      $[91] = t39;
    } else {
      t39 = $[91];
    }
    let t40;
    if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
      t40 = <span className="text-sm text-gray-600">Numer zwrotu:</span>;
      $[92] = t40;
    } else {
      t40 = $[92];
    }
    let t41;
    if ($[93] !== customReturn.customReturn.idOrderReturn) {
      t41 = <div>{t40}<p className="font-semibold">{customReturn.customReturn.idOrderReturn}</p></div>;
      $[93] = customReturn.customReturn.idOrderReturn;
      $[94] = t41;
    } else {
      t41 = $[94];
    }
    let t42;
    if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
      t42 = <span className="text-sm text-gray-600">Złożone:</span>;
      $[95] = t42;
    } else {
      t42 = $[95];
    }
    let t43;
    if ($[96] !== customReturn.customReturn.dateAdd) {
      t43 = formatDate(customReturn.customReturn.dateAdd);
      $[96] = customReturn.customReturn.dateAdd;
      $[97] = t43;
    } else {
      t43 = $[97];
    }
    let t44;
    if ($[98] !== t43) {
      t44 = <div>{t42}<p className="font-semibold">{t43}</p></div>;
      $[98] = t43;
      $[99] = t44;
    } else {
      t44 = $[99];
    }
    let t45;
    if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
      t45 = <span className="text-sm text-gray-600">Metoda zwrotu:</span>;
      $[100] = t45;
    } else {
      t45 = $[100];
    }
    let t46;
    if ($[101] !== customReturn.customReturn.returnMethod.title) {
      t46 = <p className="font-semibold">{customReturn.customReturn.returnMethod.title}</p>;
      $[101] = customReturn.customReturn.returnMethod.title;
      $[102] = t46;
    } else {
      t46 = $[102];
    }
    let t47;
    if ($[103] !== customReturn.inpostReturnCode.message || $[104] !== customReturn.inpostReturnCode.showCode) {
      t47 = customReturn.inpostReturnCode.showCode && <div className="mt-4"><span className="text-sm text-gray-600">Kod zwrotu:</span><div className="flex items-center gap-2"><p className="font-semibold font-mono text-lg tracking-wider">{customReturn.inpostReturnCode.message?.replace(/(.{3})(.{3})(.{3})(.{1})/, "$1 $2 $3 $4")}</p><button onClick={() => {
            navigator.clipboard.writeText(customReturn.inpostReturnCode.message);
          }} className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors" title="Skopiuj kod"><svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg></button></div></div>;
      $[103] = customReturn.inpostReturnCode.message;
      $[104] = customReturn.inpostReturnCode.showCode;
      $[105] = t47;
    } else {
      t47 = $[105];
    }
    let t48;
    if ($[106] !== t46 || $[107] !== t47) {
      t48 = <div>{t45}{t46}{t47}</div>;
      $[106] = t46;
      $[107] = t47;
      $[108] = t48;
    } else {
      t48 = $[108];
    }
    let t49;
    if ($[109] !== t41 || $[110] !== t44 || $[111] !== t48) {
      t49 = <div className="grid grid-cols-2 md:grid-cols-4 gap-4">{t41}{t44}{t48}</div>;
      $[109] = t41;
      $[110] = t44;
      $[111] = t48;
      $[112] = t49;
    } else {
      t49 = $[112];
    }
    let t50;
    if ($[113] !== customReturn.customReturn.idOrderReturn || $[114] !== customReturn.customReturn.returnMethod.title || $[115] !== customReturn.paymentStatus.payAgain || $[116] !== onGetDhlLabel) {
      t50 = customReturn.paymentStatus.payAgain === "0" && customReturn.customReturn.returnMethod.title === "Zwrot do punktu DHL POP" && <div className="mb-6 border border-red-200 p-3 flex justify-center gap-2 bg-red-50 cursor-pointer mt-4" onClick={() => onGetDhlLabel(customReturn.customReturn.idOrderReturn)}><div className="flex gap-2"><LocalShipping /><Text text={"Pobierz etykiet\u0119 DHL"} weight={TextWeight.BOLD} /></div></div>;
      $[113] = customReturn.customReturn.idOrderReturn;
      $[114] = customReturn.customReturn.returnMethod.title;
      $[115] = customReturn.paymentStatus.payAgain;
      $[116] = onGetDhlLabel;
      $[117] = t50;
    } else {
      t50 = $[117];
    }
    let t51;
    if ($[118] !== customReturn.customReturn.returnMethod.instruction || $[119] !== customReturn.paymentStatus.payAgain) {
      t51 = customReturn.paymentStatus.payAgain === "0" && <div className="mt-4"><span className="text-sm text-gray-600">Instrukcja zwrotu:</span><div className="mt-2 leading-6" dangerouslySetInnerHTML={{
          __html: customReturn.customReturn.returnMethod.instruction
        }} /></div>;
      $[118] = customReturn.customReturn.returnMethod.instruction;
      $[119] = customReturn.paymentStatus.payAgain;
      $[120] = t51;
    } else {
      t51 = $[120];
    }
    let t52;
    if ($[121] !== t49 || $[122] !== t50 || $[123] !== t51) {
      t52 = <div className="bg-gray-50 shadow-sm p-6 mb-6">{t49}{t50}{t51}</div>;
      $[121] = t49;
      $[122] = t50;
      $[123] = t51;
      $[124] = t52;
    } else {
      t52 = $[124];
    }
    if ($[125] !== t39 || $[126] !== t52) {
      t12 = <>{t38}{t39}{t52}</>;
      $[125] = t39;
      $[126] = t52;
      $[127] = t12;
    } else {
      t12 = $[127];
    }
    if ($[128] !== customReturn.customReturn.p24Amount || $[129] !== customReturn.customReturn.paymentMethod || $[130] !== customReturn.paymentStatus.title) {
      t13 = customReturn.customReturn.paymentMethod !== "withoutpayment" && <><div className="mb-6"><Text text={"Informacje o p\u0142atno\u015Bci"} variant={TextVariant.H6} weight={TextWeight.BOLD} /></div><div className="bg-gray-50 shadow-sm p-6 mb-6"><div className="grid grid-cols-2 md:grid-cols-4 gap-4"><div><span className="text-sm text-gray-600">Sposób płatności:</span><p className="font-semibold">{customReturn.customReturn.paymentMethod}</p></div>{customReturn.customReturn.paymentMethod === "przelewy24" && <div><span className="text-sm text-gray-600">Koszt zwrotu:</span><p className="font-semibold">{customReturn.customReturn.p24Amount} zł</p></div>}<div><span className="text-sm text-gray-600">Status płatności:</span><p className="font-semibold">{customReturn.paymentStatus.title}</p></div></div></div></>;
      $[128] = customReturn.customReturn.p24Amount;
      $[129] = customReturn.customReturn.paymentMethod;
      $[130] = customReturn.paymentStatus.title;
      $[131] = t13;
    } else {
      t13 = $[131];
    }
    let t53;
    if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
      t53 = <Text text="Dane zwrotu" weight={TextWeight.BOLD} />;
      $[132] = t53;
    } else {
      t53 = $[132];
    }
    let t54;
    if ($[133] !== customReturn.orderReturnAddress.returnName) {
      t54 = <Text text={customReturn.orderReturnAddress.returnName} fontSize={TextSize.S} />;
      $[133] = customReturn.orderReturnAddress.returnName;
      $[134] = t54;
    } else {
      t54 = $[134];
    }
    const t55 = `${customReturn.orderReturnAddress.returnStreet} ${customReturn.orderReturnAddress.returnHouseNumber}${customReturn.orderReturnAddress.returnApartmentNumber !== "" ? `/${customReturn.orderReturnAddress.returnApartmentNumber}` : ""}`;
    let t56;
    if ($[135] !== t55) {
      t56 = <Text text={t55} fontSize={TextSize.S} />;
      $[135] = t55;
      $[136] = t56;
    } else {
      t56 = $[136];
    }
    const t57 = `${customReturn.orderReturnAddress.returnPostcode} ${customReturn.orderReturnAddress.returnCity}`;
    let t58;
    if ($[137] !== t57) {
      t58 = <Text text={t57} fontSize={TextSize.S} />;
      $[137] = t57;
      $[138] = t58;
    } else {
      t58 = $[138];
    }
    const t59 = `${customReturn.orderReturnAddress.returnPhone}`;
    let t60;
    if ($[139] !== t59) {
      t60 = <Text text={t59} fontSize={TextSize.S} />;
      $[139] = t59;
      $[140] = t60;
    } else {
      t60 = $[140];
    }
    let t61;
    if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
      t61 = <Text text="Konto bankowe:" fontSize={TextSize.S} weight={TextWeight.SEMIBOLD} className="mt-2" />;
      $[141] = t61;
    } else {
      t61 = $[141];
    }
    let t62;
    if ($[142] !== customReturn.orderReturnAddress.accountNumberReturn) {
      t62 = formatAccountNumber(customReturn.orderReturnAddress.accountNumberReturn);
      $[142] = customReturn.orderReturnAddress.accountNumberReturn;
      $[143] = t62;
    } else {
      t62 = $[143];
    }
    let t63;
    if ($[144] !== t62) {
      t63 = <Text text={t62} fontSize={TextSize.S} />;
      $[144] = t62;
      $[145] = t63;
    } else {
      t63 = $[145];
    }
    if ($[146] !== t54 || $[147] !== t56 || $[148] !== t58 || $[149] !== t60 || $[150] !== t63) {
      t14 = <><div className="grid md:grid-cols-2 gap-6"><div className="bg-gray-50 shadow-sm p-6 mb-6 flex flex-col gap-2">{t53}<div className="flex flex-col gap-1">{t54}{t56}{t58}{t60}{t61}{t63}</div></div></div></>;
      $[146] = t54;
      $[147] = t56;
      $[148] = t58;
      $[149] = t60;
      $[150] = t63;
      $[151] = t14;
    } else {
      t14 = $[151];
    }
    t7 = "bg-gray-50 shadow-sm p-6 mb-6";
    if ($[152] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Text text={"Lista zwr\xF3conych produkt\xF3w"} weight={TextWeight.BOLD} className="mb-4" />;
      $[152] = t8;
    } else {
      t8 = $[152];
    }
    t5 = "space-y-4 mb-12 md:mb-4 -mx-3 md:mx-0";
    t6 = renderProducts(productsArray);
    $[6] = customReturn.customReturn.dateAdd;
    $[7] = customReturn.customReturn.idOrderReturn;
    $[8] = customReturn.customReturn.p24Amount;
    $[9] = customReturn.customReturn.paymentMethod;
    $[10] = customReturn.customReturn.returnMethod.instruction;
    $[11] = customReturn.customReturn.returnMethod.title;
    $[12] = customReturn.inpostReturnCode.message;
    $[13] = customReturn.inpostReturnCode.showCode;
    $[14] = customReturn.order.details?.id;
    $[15] = customReturn.order.details?.orderDate;
    $[16] = customReturn.order.details?.payment;
    $[17] = customReturn.order.details?.shipping;
    $[18] = customReturn.orderReturn.printUrl;
    $[19] = customReturn.orderReturnAddress.accountNumberReturn;
    $[20] = customReturn.orderReturnAddress.returnApartmentNumber;
    $[21] = customReturn.orderReturnAddress.returnCity;
    $[22] = customReturn.orderReturnAddress.returnHouseNumber;
    $[23] = customReturn.orderReturnAddress.returnName;
    $[24] = customReturn.orderReturnAddress.returnPhone;
    $[25] = customReturn.orderReturnAddress.returnPostcode;
    $[26] = customReturn.orderReturnAddress.returnStreet;
    $[27] = customReturn.paymentStatus.payAgain;
    $[28] = customReturn.paymentStatus.title;
    $[29] = customReturn.returnedProducts;
    $[30] = getCurrentOrderState;
    $[31] = getTrackingNumber;
    $[32] = isMobile;
    $[33] = onGetDhlLabel;
    $[34] = onPayAgain;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
  } else {
    t10 = $[35];
    t11 = $[36];
    t12 = $[37];
    t13 = $[38];
    t14 = $[39];
    t5 = $[40];
    t6 = $[41];
    t7 = $[42];
    t8 = $[43];
    t9 = $[44];
  }
  let t15;
  if ($[153] !== t5 || $[154] !== t6) {
    t15 = <div className={t5}>{t6}</div>;
    $[153] = t5;
    $[154] = t6;
    $[155] = t15;
  } else {
    t15 = $[155];
  }
  let t16;
  if ($[156] !== t15 || $[157] !== t7 || $[158] !== t8) {
    t16 = <><div className={t7}>{t8}{t15}</div></>;
    $[156] = t15;
    $[157] = t7;
    $[158] = t8;
    $[159] = t16;
  } else {
    t16 = $[159];
  }
  let t17;
  if ($[160] !== t10 || $[161] !== t11 || $[162] !== t12 || $[163] !== t13 || $[164] !== t14 || $[165] !== t16 || $[166] !== t9) {
    t17 = <div>{t9}{t10}{t11}{t12}{t13}{t14}{t16}</div>;
    $[160] = t10;
    $[161] = t11;
    $[162] = t12;
    $[163] = t13;
    $[164] = t14;
    $[165] = t16;
    $[166] = t9;
    $[167] = t17;
  } else {
    t17 = $[167];
  }
  return t17;
};
const SliderWrapper = styled.div`
  .slick-track {
    display: flex;
    gap: 10px;
  }

  .slick-list {
    margin-left: -10px;
  }

  .slick-dots {
    bottom: -30px;
    li {
      button:before {
        font-size: 30px;
        color: ${({
  theme
}) => theme.colors.BLACK};
      }
    }
  }
`;
export default ReturnDetails;
function _temp(dateString) {
  if (!dateString) {
    return "Brak danych";
  }
  return new Date(dateString).toLocaleDateString("pl-PL");
}
function _temp2(product) {
  const {
    name,
    size,
    color
  } = parseProductName(product.productName);
  return {
    ...product,
    name,
    size,
    color
  };
}
function _temp3(product_0) {
  return <ReturnedProductListItem key={product_0.idOrderDetail} product={product_0} />;
}
function _temp4(product_1) {
  return <ReturnedProductListItem key={product_1.idOrderDetail} product={product_1} />;
}
function _temp5(accountNumber) {
  if (!accountNumber) {
    return "Brak numeru konta";
  }
  const cleanNumber = accountNumber.replace(/\s+/g, "").replace(/[^0-9]/g, "");
  if (cleanNumber.length === 26) {
    return cleanNumber.replace(/(.{2})(.{4})(.{4})(.{4})(.{4})(.{4})(.{4})/, "$1 $2 $3 $4 $5 $6 $7");
  }
  if (cleanNumber.length >= 15 && cleanNumber.length <= 34) {
    return cleanNumber.replace(/(.{4})/g, "$1 ").trim();
  }
  return cleanNumber.replace(/(.{4})/g, "$1 ").trim();
}